var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmenttype),
      expression: "shipmenttype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShipmentType')
    },
    attrs: {
      "name": "shipmenttype",
      "id": "shipmenttype"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shipmenttype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetFormFields('shipmentTypeSelection')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _c('option', [_vm._v("RTO")]), _vm._v(" "), _c('option', [_vm._v("DTO")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.shipmenttype')),
      expression: "errors.has('form-2.shipmenttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Delivery Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Hub")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "name": "hubname",
      "id": "hubname",
      "disabled": "disabled"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubServiceCenterList), function(hub_obj) {
    return _c('option', {
      domProps: {
        "value": hub_obj.HubID
      }
    }, [_vm._v(_vm._s(hub_obj.HubName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.hubname')),
      expression: "errors.has('form-2.hubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Hub")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Delivery User :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.deliveryList,
      "selected-option": _vm.deliveryObj,
      "name": "deliverUserName",
      "placeholder": "Select user"
    },
    on: {
      "select": _vm.getdeliveyList
    },
    model: {
      value: (_vm.deliverUserName),
      callback: function($$v) {
        _vm.deliverUserName = $$v
      },
      expression: "deliverUserName"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliverUserName')),
      expression: "errors.has('deliverUserName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('deliverUserName')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.disabledcount == 1,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.ShowShipmentDetails(null)
      }
    }
  }, [_vm._v("Show")])])], 1)])]), _vm._v(" "), (_vm.checkCount == 1) ? _c('div', [_c('legend', [_vm._v("Update Shipment Details")])]) : _vm._e(), _vm._v(" "), (_vm.checkCount == 1) ? _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-2')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Delivery Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dateobj.toDate),
      expression: "dateobj.toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate"
    },
    domProps: {
      "value": (_vm.dateobj.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dateobj, "toDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.toDate')),
      expression: "errors.has('form-2.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Delivery Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.time),
      expression: "time"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$/
      }),
      expression: "{required: true, regex: /^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$/}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('Time')
    },
    attrs: {
      "id": "time",
      "type": "text",
      "name": "time",
      "placeholder": "HH:MM:SS"
    },
    domProps: {
      "value": (_vm.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.time = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.time')),
      expression: "errors.has('form-2.time')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Time")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status Code")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusCode),
      expression: "statusCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('statusCode')
    },
    attrs: {
      "name": "statusCode",
      "id": "statusCode"
    },
    on: {
      "click": function($event) {
        return _vm.showdisputereason($event)
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.ReasonStatusArr), function(Reason_status) {
    return _c('option', {
      domProps: {
        "value": Reason_status.uniquecode
      }
    }, [_vm._v(_vm._s(Reason_status.userprocess))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.statusCode')),
      expression: "errors.has('form-2.statusCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Status Code")])]), _vm._v(" "), (_vm.reciverflage == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Receiver Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.receiverName),
      expression: "receiverName"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('receiverName')
    },
    attrs: {
      "type": "text",
      "name": "receiverName"
    },
    domProps: {
      "value": (_vm.receiverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.receiverName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.receiverName')),
      expression: "errors.has('form-1.receiverName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Receiver Name")])]) : _vm._e(), _vm._v(" "), (_vm.reciverflage == null) ? _c('div', {
    staticClass: "col-md-3"
  }) : _vm._e(), _vm._v(" "), (_vm.disputevalidator == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Dispute Code")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disputeCode),
      expression: "disputeCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('disputeCode')
    },
    attrs: {
      "name": "disputeCode",
      "id": "disputeCode"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.disputeCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeDisputeCode]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.DisputeStatusArr), function(Reason_status) {
    return _c('option', {
      domProps: {
        "value": Reason_status.uniquecode
      }
    }, [_vm._v(_vm._s(Reason_status.userprocess))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.disputeCode')),
      expression: "errors.has('form-2.disputeCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Status Code")])]) : _vm._e(), _vm._v(" "), (_vm.subDisputeCodeFlag == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Sub - Dispute Code")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subDisputeCode),
      expression: "subDisputeCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('subDisputeCode')
    },
    attrs: {
      "name": "disputeCode",
      "id": "subDisputeCode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subDisputeCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.subDisputeStatusReasonCodes), function(sub_Reason_Status) {
    return _c('option', {
      domProps: {
        "value": sub_Reason_Status.uniquecode
      }
    }, [_vm._v(_vm._s(sub_Reason_Status.title))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.subDisputeCode')),
      expression: "errors.has('form-2.subDisputeCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select sub dispute Status Code")])]) : _vm._e(), _vm._v(" "), (_vm.reattemptDeliveryDateShow == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" Reattempt Date")]), _vm._v(" "), _c('v-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.reattemptDeliveryDateShow == true ? 'required' : ''),
      expression: "reattemptDeliveryDateShow == true ? 'required' : '' "
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ReattemptDate')
    },
    attrs: {
      "min-date": new Date(new Date().setDate(new Date().getDate() + 1)),
      "max-date": new Date(new Date().setDate(new Date().getDate() + 7)),
      "placeholder": "Select ReattemptDate Date",
      "name": "ReattemptDate"
    },
    model: {
      value: (_vm.dateobj.ReattemptDate),
      callback: function($$v) {
        _vm.$set(_vm.dateobj, "ReattemptDate", $$v)
      },
      expression: "dateobj.ReattemptDate"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.ReattemptDate')),
      expression: "errors.has('form-2.ReattemptDate')"
    }],
    staticClass: "text-danger",
    staticStyle: {}
  }, [_vm._v("Please Select\n                  Reattempt Date.")])], 1) : _vm._e(), _vm._v(" "), (_vm.whdisputeCodevalue == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("POD Remarks")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.whdisputeCode),
      expression: "whdisputeCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('whdisputeCode')
    },
    attrs: {
      "name": "whdisputeCode",
      "id": "whdisputeCode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.whdisputeCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.reasontypedata), function(ReasonType) {
    return _c('option', {
      domProps: {
        "value": ReasonType.Reason
      }
    }, [_vm._v(_vm._s(ReasonType.Reason))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.whdisputeCode')),
      expression: "errors.has('form-2.whdisputeCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Status Code")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.checkCount == 1) ? _c('legend', [_vm._v("Shipment Details List")]) : _vm._e(), _vm._v(" "), (_vm.checkCount == 1) ? _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": ""
    },
    on: {
      "click": _vm.clear
    }
  }), _vm._v(" \n      "), _c('span', {
    staticClass: "bagin-dtl1"
  }, [_vm._v("Total Shipments   : " + _vm._s(_vm.totalCountpagi))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awb),
      expression: "awb"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter ShippingId / AWB",
      "name": "awb",
      "rows": "2",
      "id": "awb"
    },
    domProps: {
      "value": (_vm.awb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awb = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', [_c('b-input-group', {
    staticClass: "topspace input-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ShowShipmentDetails(1)
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("Clear")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "sample-awb-eg col-md-3"
  }, [_vm._v("Maximum 10 shipping IDs permitted for bulk processing.\nMultiple shipping IDs can be separated using comma or  next line (↵/,).")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered bg-color tbl datatable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItemdata),
      expression: "selectedItemdata"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedItemdata) ? _vm._i(_vm.selectedItemdata, null) > -1 : (_vm.selectedItemdata)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": function($event) {
        var $$a = _vm.selectedItemdata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectedItemdata = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectedItemdata = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectedItemdata = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.successArr.length || _vm.failedArr.length) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShipName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShipAddress")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShipPinCode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SRName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AssignBatchNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AssignDate")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SrNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CompanyName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShipmentStatus")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.LatmileShipmentData), function(val) {
    return (_vm.tblErrorshowflag !== 1) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItems),
        expression: "selectedItems"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": val.ShippingID,
        "checked": Array.isArray(_vm.selectedItems) ? _vm._i(_vm.selectedItems, val.ShippingID) > -1 : (_vm.selectedItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedItems = $$c
          }
        }, function($event) {
          return _vm.setcheckbox($event)
        }]
      }
    })]), _vm._v(" "), (_vm.successArr.length) ? _c('td', {
      staticStyle: {
        "width": "73px"
      }
    }, _vm._l((_vm.successArr), function(val2) {
      return (val2.ShippingID == val.ShippingID) ? _c('span', {
        staticClass: "successlink",
        on: {
          "click": function($event) {
            return _vm.getshipmentviewdata(val.ShippingID)
          }
        }
      }, [_vm._v("Success")]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (_vm.failedArr.length) ? _c('td', {
      staticStyle: {
        "width": "73px"
      }
    }, _vm._l((_vm.failedArr), function(val3) {
      return (val3.ShippingID == val.ShippingID) ? _c('span', {
        staticClass: "failedlink",
        on: {
          "click": function($event) {
            return _vm.getshipmentviewdata(val.ShippingID)
          }
        }
      }, [_vm._v("Failed")]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.SRName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.AssignBatchNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.AssignDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.SrNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.CompanyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.ShipmentStatus))])]) : _vm._e()
  }), _vm._v(" "), (_vm.LatmileShipmentData.length == 0 || _vm.tblErrorshowflag == 1) ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.tblErrorshowflag !== 1) ? _c('div', [_c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.Loading
    },
    on: {
      "update:active": function($event) {
        _vm.Loading = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-dialog modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.shipmentviewdataflag = false
      }
    },
    model: {
      value: (_vm.shipmentviewdataflag),
      callback: function($$v) {
        _vm.shipmentviewdataflag = $$v
      },
      expression: "shipmentviewdataflag"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Shipment Details ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeonPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._l((_vm.viewShipmentData), function(valcheck) {
    return (_vm.viewShipmentData.length != 0) ? _c('div', [_c('form', {
      attrs: {
        "data-vv-scope": "form-1"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.validateForm('form-1')
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [(valcheck.ShippingID == _vm.storeShippingid) ? _c('div', {
      staticClass: "col-lg-7"
    }, [_c('h5', [_vm._v("Shipping ID : " + _vm._s(valcheck.ShippingID))])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(valcheck.ShippingID == _vm.storeShippingid) ? _c('div', {
      staticClass: "col-lg-9 lg-auto"
    }, [_vm._v("Status : " + _vm._s(valcheck.message))]) : _vm._e(), _vm._v(" "), (valcheck.ShippingID == _vm.storeShippingid && valcheck.updateFrameworkData) ? _c('div', {
      staticClass: "col-lg-9 lg-auto"
    }, [_vm._v(_vm._s(valcheck.Status))]) : _vm._e()])])]) : _vm._e()
  }), _vm._v(" "), (_vm.viewShipmentData.length == 0) ? _c('div', [_c('p', [_vm._v("Shipment update status not found")])]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.LoaderForPopup
    },
    on: {
      "update:active": function($event) {
        _vm.LoaderForPopup = $event
      }
    }
  })], 2)])])], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('legend', [_vm._v("Add RTO/DTO Delivery Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "35"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "32em"
    }
  }, [_c('b', [_vm._v("Shipment details not found")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050bcc25","hasScoped":true}!./src/views/components/RTODeliveryStatus/RTODeliveryStatus.component.html
// module id = 1165
// module chunks = 1